"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
var _memberManagement = require("@/api/member/memberManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PhoneUserSelect',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    placeholder: {
      type: String,
      default: '请输入手机号'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '200px'
    }
  },
  data: function data() {
    return {
      options: [],
      loading: false,
      debounceTimer: null,
      imgPath: process.env.VUE_APP_IMAGE_PATH,
      // 缓存已选中的用户对象，便于回显label
      selectedUser: null
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (!val) {
          this.selectedUser = null;
        } else if (!this.selectedUser || this.selectedUser.userId !== val) {
          // 外部赋值时尝试从已有options匹配
          var match = this.options.find(function (o) {
            return o.userId === val;
          });
          if (match) this.selectedUser = match;
        }
      },
      immediate: true
    }
  },
  methods: {
    handleSearch: function handleSearch(keyword) {
      var _this = this;
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        if (!keyword || String(keyword).trim().length < 1) {
          _this.options = [];
          return;
        }
        _this.loading = true;
        (0, _memberManagement.searchUserByPhone)(String(keyword).trim()).then(function (res) {
          // 兼容后端返回结构
          var list = Array.isArray(res) ? res : res && res.data || res && res.records || [];
          _this.options = list;
          // 若当前已选中，保留选中对象
          if (_this.value) {
            var match = list.find(function (o) {
              return o.userId === _this.value;
            });
            if (match) _this.selectedUser = match;
          }
        }).catch(function () {
          _this.options = [];
        }).finally(function () {
          _this.loading = false;
        });
      }, 300);
    },
    handleChange: function handleChange(userId) {
      var match = this.options.find(function (o) {
        return o.userId === userId;
      }) || null;
      this.selectedUser = match;
      this.$emit('input', userId || null);
      this.$emit('select', match);
    },
    handleClear: function handleClear() {
      this.options = [];
      this.selectedUser = null;
      this.$emit('input', null);
      this.$emit('select', null);
    },
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) {
        return userpic;
      }
      return this.imgPath + userpic;
    }
  }
};